import { utilBuildings } from "../utils/utilBuildings";
import { selectBuildingInfoById, selectExistingBuildingInfo } from "./selectExistingBuildingInfo";
export var selectBuildingConstructionInProgress = function (state) {
    var buildings = state.baseInfo.buildings;
    if (!buildings) {
        return undefined;
    }
    var buildingInProgress = buildings.find(function (building) {
        var buildingData = selectBuildingInfoById(state, building.id);
        return buildingData !== undefined ? utilBuildings.isUnderConstruction(buildingData) : true;
    });
    if (!buildingInProgress) {
        return undefined;
    }
    return selectExistingBuildingInfo(state, buildingInProgress);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectBuildingConstructionInProgress.ts
// module id = 249
// module chunks = 3